import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=1a079b21&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=1a079b21&prod&lang=scss&scoped=true"
import style1 from "./Admin.vue?vue&type=style&index=1&id=1a079b21&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a079b21",
  null
  
)

export default component.exports